import React, { useEffect, useState } from 'react';
import { ContactUsFormSection, prefix } from '@/components/ContactUs/ContactUsFormSection';
import { Layout } from '@/components/Layout';
import { handleFormSubmit } from '@/utils/handleFormSubmit';
import { appSettings } from '@visalex/configs';
import { Col, Hero } from '@visalex/core';
import { SelectOption } from '@visalex/forms';

import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import styles from '@/components/ContactUs/ContactUs.module.scss';

const ContactUs = () => {
  const { t, i18n } = useTranslation();
  const [pageIsLoading, setPageIsLoading] = useState(true);
  const [nationalities, setNationalities] = useState<SelectOption[]>([]);

  useEffect(() => {
    setPageIsLoading(true);

    if (i18n.language) {
      fetch(new URL(`/country-list/${i18n.language || 'en'}.json`, location.origin))
        .then((res) => res.json())
        .then((countries: Array<string[]>) => {
          const nations: SelectOption[] = [];

          countries.forEach((country) => {
            if (country[2]) {
              nations.push({ label: country[2], value: country[0] });
            }
          });
          setNationalities(nations);
          setPageIsLoading(false);
        });
    }
  }, [i18n.language]);

  const languages = appSettings.supportedLanguages.map(({ language }) => {
    return {
      label: t(`action-bar.locales.${language}`),
      value: language,
    };
  });

  const { handleSubmit, isSubmitWithError, isLoading } = handleFormSubmit();

  return (
    <Layout title={t(`${prefix}.seo-title`)} description={t(`${prefix}.seo-description`)}>
      <div className={styles[`${prefix}`]}>
        <Hero className={styles[`${prefix}__hero`]}>
          <Col xs={12} lg={8} className="mx-auto">
            <h1 dangerouslySetInnerHTML={{ __html: t(`${prefix}.title`) }} />
            <p dangerouslySetInnerHTML={{ __html: t(`${prefix}.subtitle`) }} />
          </Col>
        </Hero>
        <ContactUsFormSection
          pageIsLoading={pageIsLoading}
          nationalities={nationalities}
          languages={languages}
          handleSubmit={handleSubmit}
          isSubmitWithError={isSubmitWithError}
          isLoading={isLoading}
        />
      </div>
    </Layout>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}

export default ContactUs;
